import ApiRequest from "../apiRequest";
import { Quiz } from "../../types/Quiz";

interface postQuizMetadataOut {
  error?: string;
  quiz?: Quiz;
}
export default async function postQuizMetadata(quiz: Quiz): Promise<postQuizMetadataOut> {

  try {
    let result = await ApiRequest(
      `/api/quiz${quiz.id ? `/${quiz.id}` : ''}`,
      'POST',
      JSON.stringify({
        quiz
      })
    )

    return {
      // @ts-ignore
      error: result.error,
      // @ts-ignore
      quiz: result.quiz
    }
  } catch (err) {
    console.error("could not post attempt details", err);
    return {
      error: 'Unable to post attempt'
    }
  }
}